import { render, staticRenderFns } from "./UserFamilyDelete.vue?vue&type=template&id=33ed39b2&"
import script from "./UserFamilyDelete.vue?vue&type=script&lang=js&"
export * from "./UserFamilyDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports